export enum ChangeDirection {
  Up = "up",
  Down = "down",
  NoChange = "noChange",
}
